import {
  createCodeableConcept,
  createIdentifier,
  findIdentifier,
  getFirstCodeFromCodableConcepts,
  getIdentifier,
  IdentifierCode,
  type WithId,
} from '@quromedical/fhir-common';

import { type MessageTemplate, MessageTemplateSchema } from './schema';

export const mapTemplateModelToFhirLibrary = (
  template: MessageTemplate,
): fhir4.Library => {
  const {
    name,
    content,
    active,
    effectivePeriod,
    templateId,
    type,
    id,
    system,
  } = template;

  return {
    resourceType: 'Library',
    id,
    identifier: [
      createIdentifier(IdentifierCode.libraryTemplateId, templateId, system),
    ],
    name,
    status: active ? 'active' : 'retired',
    type: createCodeableConcept(type),
    description: content,
    effectivePeriod,
  };
};

export const mapFhirLibraryToTemplateModel = (
  fhir: WithId<fhir4.Library>,
): MessageTemplate => {
  const { name, status, description, id, identifier, effectivePeriod } = fhir;

  const template = {
    id,
    name,
    active: status === 'active',
    content: description,
    effectivePeriod,
    type: getFirstCodeFromCodableConcepts([fhir.type]),
    templateId: getIdentifier(IdentifierCode.libraryTemplateId, identifier),
    system: findIdentifier(IdentifierCode.libraryTemplateId, identifier)
      ?.system,
  };

  const parsed = MessageTemplateSchema.safeParse(template);

  if (!parsed.success) {
    throw parsed.error;
  }

  return parsed.data;
};
